import { all, call, takeLatest } from 'redux-saga/effects';

import {
  addJJCoinsUser,
  createJJLikesStepRange,
  deleteJJLikesStepRange,
  editJJFortuneAvailabilitySettings,
  editJJFortunePayout,
  importJoyJetIncome,
  loadJJFortuneAvailabilitySettings,
  loadJJFortunePayouts,
  loadJJLikesStepRanges,
  loadJoyJetIncome
} from 'api/jjFortune';
import { getRange } from 'utils/rangeHelpers';
import { JJ_FORTUNE_ACTION_TYPES } from '../actions/jjFortune.actions';

function* loadJJLikesStepRangesFlow({ payload, resolve, reject }) {
  try {
    const { value, ...rest } = payload;
    let filters = rest;
    if (value) {
      filters = {
        ...filters,
        ...getRange('value', value)
      }
    }
    const { data } = yield call(loadJJLikesStepRanges, filters);
    yield call(resolve, {
      items: data['hydra:member'],
      total: data['hydra:totalItems'],
    })
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

function* createJJLikesStepRangesFlow({ payload, resolve, reject }) {
  try {
    const { data } = yield call(createJJLikesStepRange, payload);
    yield call(resolve, data)
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

function* deleteJJLikesStepRangesFlow({ payload, resolve, reject }) {
  try {
    yield call(deleteJJLikesStepRange, payload);
    yield call(resolve)
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

function* loadJJFortuneAvailabilitySettingsFlow({ payload, resolve, reject }) {
  try {
    const { data } = yield call(loadJJFortuneAvailabilitySettings, payload);
    yield call(resolve, {
      items: data['hydra:member'],
      total: data['hydra:totalItems'],
    })
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

function* editJJFortuneAvailabilitySettingsFlow({ payload, resolve, reject }) {
  try {
    const { data } = yield call(editJJFortuneAvailabilitySettings, payload);
    yield call(resolve, data)
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

function* loadJJFortunePayoutsFlow({ payload, resolve, reject }) {
  try {
    const { data } = yield call(loadJJFortunePayouts, payload);
    yield call(resolve, {
      items: data['hydra:member'],
      total: data['hydra:totalItems'],
    })
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

function* editJJFortunePayoutFlow({ payload, resolve, reject }) {
  try {
    const { data } = yield call(editJJFortunePayout, payload);
    yield call(resolve, data)
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

function* loadJoyJetIncomeFlow({ payload, resolve, reject }) {
  try {
    const { data } = yield call(loadJoyJetIncome, payload);
    yield call(resolve, data)
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

function* importJoyJetIncomeFlow({ payload, resolve, reject }) {
  try {
    const { data } = yield call(importJoyJetIncome, payload);
    yield call(resolve, data)
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

function* addJJCoinsUserFlow({ payload, resolve, reject }) {
  try {
    const { data } = yield call(addJJCoinsUser, payload);
    yield call(resolve, data)
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

export default function* () {
  yield all([
    takeLatest(JJ_FORTUNE_ACTION_TYPES.LOAD_JJ_LIKES_STEP_RANGES, loadJJLikesStepRangesFlow),
    takeLatest(JJ_FORTUNE_ACTION_TYPES.CREATE_JJ_LIKES_STEP_VALUE, createJJLikesStepRangesFlow),
    takeLatest(JJ_FORTUNE_ACTION_TYPES.DELETE_JJ_LIKES_STEP_VALUE, deleteJJLikesStepRangesFlow),
    takeLatest(JJ_FORTUNE_ACTION_TYPES.LOAD_JJ_FORTUNE_AVAILABILITY_SETTINGS, loadJJFortuneAvailabilitySettingsFlow),
    takeLatest(JJ_FORTUNE_ACTION_TYPES.EDIT_JJ_FORTUNE_AVAILABILITY_SETTINGS, editJJFortuneAvailabilitySettingsFlow),
    takeLatest(JJ_FORTUNE_ACTION_TYPES.LOAD_JJ_FORTUNE_PAYOUTS, loadJJFortunePayoutsFlow),
    takeLatest(JJ_FORTUNE_ACTION_TYPES.EDIT_JJ_FORTUNE_PAYOUT, editJJFortunePayoutFlow),
    takeLatest(JJ_FORTUNE_ACTION_TYPES.LOAD_JOY_JET_INCOME, loadJoyJetIncomeFlow),
    takeLatest(JJ_FORTUNE_ACTION_TYPES.IMPORT_JOY_JET_INCOME, importJoyJetIncomeFlow),
    takeLatest(JJ_FORTUNE_ACTION_TYPES.ADD_JJ_COINS_USER, addJJCoinsUserFlow),
  ]);
}